

import { useRouter } from "vue-router";
import { defineComponent, ref } from "vue";
import { getMyOrderLoveHelp, getMyPublicHelp, getGetMyList } from "@/api/NeighborMy";
import { CancelLoveHelp, UserCompletellLoveHelp, ConfirmCompleteLoveHelpStatus } from "@/api/NeighborHelpOrder";
import { putCancelLoveHelp, putPublicLoveHelp } from "@/api/NeighborLoveHelpApi"; //爱心求助

//导入组件
import HelpWithLoveItem from "@/views/mulin/components/HelpWithLoveItem.vue";
import interactiveOrActivity from '@/views/mulin/components/InteractiveOrActivity.vue'
import ReasonDialog from "@/views/mulin/mutualAid/ReasonDialog.vue";


export default defineComponent({
    setup() {
        const router = useRouter();
        const reasonDialog = ref(null);

        return {
            router,
            reasonDialog,

        };

    },
    components: {
        //注册组件
        ReasonDialog,
        HelpWithLoveItem,
        interactiveOrActivity,
    },
    data() {
        return {
            searchParams: {

            },
            active: 0,
        };
    },

    methods: {

        rendered() {
            this.active = Number(this.$route.params.id);
        },
        async loadwobangzhubierenActivitiy({ setData }) {
            const params = {
                ...this.searchParams,
            };
            const response = (await getMyOrderLoveHelp(params)) || {
                rows: [],
            };
            setData(response.rows, response.total);
        },
        async loadwodeqiuzhuActivitiy({ setData }) {
            const params = {
                ...this.searchParams,
            };
            const response = (await getMyPublicHelp(params)) || {
                rows: [],
            };
            setData(response.rows, response.total);
        },
        async loadwodefatieActivitiy({ setData }) {
            const params = {
                ...this.searchParams,
            };
            const response = (await getGetMyList(params)) || {
                rows: [],
            };
            setData(response.rows, response.total);
        },
        async onHelpWithLoveItemResult(id, msg) {
            console.log(id + "++++" + msg);
            //删除自己发布的订单
            if (msg == "Order_Detele") {
                this.reasonDialog.showDialog(id, "fromPublisher");
                return;
            }
            //取消接受别人发布的订单
            if (msg == "Contacts_Cancel_Btn") {
                this.reasonDialog.showDialog(id, "fromRecipient");
                return;
            }
            //完成别人发布的订单
            if (msg == "Order_Comfin_Finish") {
                let params = {
                    id: id,
                    loveHelpId: id,
                };
                var isokUserCompletellLoveHelp = await UserCompletellLoveHelp(params);

                if (isokUserCompletellLoveHelp) {
                    this.$toast.success("完成订单");
                    this.reasonDialog.dismissDialog();
                } else {
                    this.$toast.fail('失败');
                }

                return;
            }

            //我的订单 编辑
            if (msg == "Order_Edit") {


                return;
            }
            //我的订单 完成 完成自己发布的订单
            if (msg == "Order_Finish") {
                let params = {
                    id: id,
                    loveHelpId: id,
                };
                var isokConfirmCompleteLoveHelpStatus = await ConfirmCompleteLoveHelpStatus(params);

                if (isokConfirmCompleteLoveHelpStatus) {
                    this.$toast.success("完成订单");
                    this.reasonDialog.dismissDialog();
                } else {
                    this.$toast.fail('失败');
                }

                return;

            }//我的订单 发布
            if (msg == "Order_Refresh") {
                var isokputPublicLoveHelp = await putPublicLoveHelp(id);

                if (isokputPublicLoveHelp) {
                    this.$toast.success("发布成功");
                    this.reasonDialog.dismissDialog();
                } else {
                    this.$toast.fail('发布失败');
                }

                return;
            }


            if (msg == "View_Detail") {
                this.router.push({
                    path: `/mulin/mutualAid/Details/${id}`,
                    query: {
                        helpActType: 2,
                    },
                });
                return;
            }
        },
        async onReasonDialogResult(id, type, radioID, msg) {
            console.log(id);
            console.log(type);
            console.log(radioID);
            console.log(msg);
            let params = {
                id: id,
                reason: msg,
                loveHelpId: id,
            };
            //删除自己发布的订单
            if (type == "fromPublisher") {
                var isokPutCancelLoveHelp = await putCancelLoveHelp(params);
                if (isokPutCancelLoveHelp) {
                    this.$toast.success("取消成功");
                    this.reasonDialog.dismissDialog();
                } else {
                    this.$toast.fail('取消失败');
                }
            }
            //取消接受别人发布的订单
            if (type == "fromRecipient") {
                var isokCancelLoveHelp = await CancelLoveHelp(params);
                if (isokCancelLoveHelp) {
                    this.$toast.success("取消成功");
                    this.reasonDialog.dismissDialog();
                } else {
                    this.$toast.fail('取消失败');
                }
            }

        },
    },

});
